import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter031() {
  return <KbChapterPage slug="chapter-031" />;
}

(Chapter031 as unknown as { path: string }).path = "/theory-album/031";
